export default "__VITE_ASSET__BffibIeN__"